import {
  ThemeType,
} from '@toolify/server/src/services/UserSettingsService/strategies/ThemeUserSettingStrategy/enum/ThemeType'
import {IThemeAttributes} from '@toolify/client/src/modules/theme/types/IThemeAttributes'
import {IThemeBootState} from '@toolify/client/src/modules/theme/types/IThemeBootState'

// Klucz i ksztalt czyta tez skrypt inline w src/index.html (przed CSS) - zmieniac w obu miejscach.
// Zapisywany tylko dla light-modern: Fiord Night i Dark startuja dokladnie jak dotad (ciemny fallback z index.html)
export const THEME_BOOT_STATE_STORAGE_KEY = 'themeBootState'
const BOOT_SURFACE_COLOR_PROPERTY = '--boot-surface-color'

export function readThemeBootState(): IThemeBootState | null {
  try {
    const state = JSON.parse(localStorage.getItem(THEME_BOOT_STATE_STORAGE_KEY) ?? 'null') as IThemeBootState | null
    return state?.attributes?.['data-theme'] === ThemeType.LightModern ? state : null
  } catch (error) {
    return null
  }
}

// Motyw do czasu pobrania uzytkownika - inaczej po starcie w light (index.html) aplikacja mrugala Fiord Night
export function readRememberedThemeType(): ThemeType | null {
  return readThemeBootState()?.attributes['data-theme'] ?? null
}

// meta color-scheme / theme-color z index.html sa ciemne (Fiord Night, Dark) - w light pasek przegladarki i
// natywne kontrolki przed CSS maja byc jasne. Pierwotna wartosc meta zostaje w data-default-content
function setThemeMetaContent(name: string, lightContent: string | null): void {
  const meta = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!meta) {
    return
  }
  meta.dataset.defaultContent ??= meta.content
  meta.content = lightContent ?? meta.dataset.defaultContent
}

// Wolane po ustawieniu atrybutow na <html> (App.vue): zapamietuje motyw light na nastepny start i synchronizuje meta
export function syncThemeBootState(attributes: Partial<IThemeAttributes>): void {
  const isLightModern = attributes['data-theme'] === ThemeType.LightModern
  const surfaceColor = isLightModern
    ? getComputedStyle(document.documentElement).getPropertyValue('--surface-color').trim()
    : ''
  document.documentElement.style.removeProperty(BOOT_SURFACE_COLOR_PROPERTY)
  setThemeMetaContent('color-scheme', isLightModern ? 'light' : null)
  setThemeMetaContent('theme-color', isLightModern && surfaceColor ? surfaceColor : null)
  try {
    if (!isLightModern) {
      localStorage.removeItem(THEME_BOOT_STATE_STORAGE_KEY)
      return
    }
    const state: IThemeBootState = {
      attributes,
      ...(surfaceColor ? {surfaceColor} : {}),
    }
    localStorage.setItem(THEME_BOOT_STATE_STORAGE_KEY, JSON.stringify(state))
  } catch (error) {
    // localStorage niedostepny (tryb prywatny) - start bez zapamietanego motywu, jak dotad
  }
}
